/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TeamRosterMember } from './TeamRosterMember';
import {
    TeamRosterMemberFromJSON,
    TeamRosterMemberFromJSONTyped,
    TeamRosterMemberToJSON,
    TeamRosterMemberToJSONTyped,
} from './TeamRosterMember';
import type { TeamStats } from './TeamStats';
import {
    TeamStatsFromJSON,
    TeamStatsFromJSONTyped,
    TeamStatsToJSON,
    TeamStatsToJSONTyped,
} from './TeamStats';
import type { TournamentFeeMode } from './TournamentFeeMode';
import {
    TournamentFeeModeFromJSON,
    TournamentFeeModeFromJSONTyped,
    TournamentFeeModeToJSON,
    TournamentFeeModeToJSONTyped,
} from './TournamentFeeMode';

/**
 * API response format for TournamentTeam
 * @export
 * @interface TournamentTeamResponse
 */
export interface TournamentTeamResponse {
    /**
     * Team ID
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamResponse
     */
    createdAt?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamResponse
     */
    updatedAt?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    name: string;
    /**
     * Short team tag like TSM
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    tag?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    logoUrl?: string;
    /**
     * Reference to Asset for team logo
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    logoId?: string;
    /**
     * User ID of team captain
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    captainId: string;
    /**
     * 
     * @type {Array<TeamRosterMember>}
     * @memberof TournamentTeamResponse
     */
    roster?: Array<TeamRosterMember>;
    /**
     * Tournament this team is registered for
     * @type {string}
     * @memberof TournamentTeamResponse
     */
    tournamentId: string;
    /**
     * Seeding position for bracket placement
     * @type {number}
     * @memberof TournamentTeamResponse
     */
    seed?: number;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentTeamResponse
     */
    checkedIn?: boolean;
    /**
     * 
     * @type {number}
     * @memberof TournamentTeamResponse
     */
    checkedInAt?: number;
    /**
     * 
     * @type {TeamStats}
     * @memberof TournamentTeamResponse
     */
    stats?: TeamStats;
    /**
     * 
     * @type {TournamentFeeMode}
     * @memberof TournamentTeamResponse
     */
    feeMode?: TournamentFeeMode;
    /**
     * Whether the team has paid the entry fee
     * @type {boolean}
     * @memberof TournamentTeamResponse
     */
    entryFeePaid?: boolean;
}



/**
 * Check if a given object implements the TournamentTeamResponse interface.
 */
export function instanceOfTournamentTeamResponse(value: object): value is TournamentTeamResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('captainId' in value) || value['captainId'] === undefined) return false;
    if (!('tournamentId' in value) || value['tournamentId'] === undefined) return false;
    return true;
}

export function TournamentTeamResponseFromJSON(json: any): TournamentTeamResponse {
    return TournamentTeamResponseFromJSONTyped(json, false);
}

export function TournamentTeamResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentTeamResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'name': json['name'],
        'tag': json['tag'] == null ? undefined : json['tag'],
        'logoUrl': json['logoUrl'] == null ? undefined : json['logoUrl'],
        'logoId': json['logoId'] == null ? undefined : json['logoId'],
        'captainId': json['captainId'],
        'roster': json['roster'] == null ? undefined : ((json['roster'] as Array<any>).map(TeamRosterMemberFromJSON)),
        'tournamentId': json['tournamentId'],
        'seed': json['seed'] == null ? undefined : json['seed'],
        'checkedIn': json['checkedIn'] == null ? undefined : json['checkedIn'],
        'checkedInAt': json['checkedInAt'] == null ? undefined : json['checkedInAt'],
        'stats': json['stats'] == null ? undefined : TeamStatsFromJSON(json['stats']),
        'feeMode': json['feeMode'] == null ? undefined : TournamentFeeModeFromJSON(json['feeMode']),
        'entryFeePaid': json['entryFeePaid'] == null ? undefined : json['entryFeePaid'],
    };
}

export function TournamentTeamResponseToJSON(json: any): TournamentTeamResponse {
    return TournamentTeamResponseToJSONTyped(json, false);
}

export function TournamentTeamResponseToJSONTyped(value?: TournamentTeamResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'name': value['name'],
        'tag': value['tag'],
        'logoUrl': value['logoUrl'],
        'logoId': value['logoId'],
        'captainId': value['captainId'],
        'roster': value['roster'] == null ? undefined : ((value['roster'] as Array<any>).map(TeamRosterMemberToJSON)),
        'tournamentId': value['tournamentId'],
        'seed': value['seed'],
        'checkedIn': value['checkedIn'],
        'checkedInAt': value['checkedInAt'],
        'stats': TeamStatsToJSON(value['stats']),
        'feeMode': TournamentFeeModeToJSON(value['feeMode']),
        'entryFeePaid': value['entryFeePaid'],
    };
}

